<div class="modal-body">
  <div id="modal-header-wrapper">
    <h2 id="title-text">{{ isUpdateMode() ? 'Modifier une tâche à réaliser' : 'Planifier une tâche à réaliser' }}</h2>
  </div>

  <div *ngIf="toDo" id="modal-content-wrapper">

    <div *ngIf="toDo.target else patientTemplate" class="form-row-wrapper">
      <div class="form-field input-row">
        <label>Patient</label>
        <div class="todo-target">
          <div class="icon">
            <i-bs name="person-fill"></i-bs>
          </div>
          <div class="label">{{ getLabelTarget(toDo.target) }}</div>
        </div>
      </div>
      <div *ngIf="!withPatient" class="patient-button-wrapper">
        <button (click)="patientSelector()" type="button" class="btn btn-outline-primary btn-outline w-100">
          Patient
        </button>
      </div>
    </div>
    <ng-template #patientTemplate>
      <div class="form-row-wrapper">
        <div class="form-field input-row">
          <label>Patient ( optionnel )</label>
          <div class="w-100">
            <button (click)="patientSelector()" type="button" class="btn btn-outline-primary btn-outline w-100">
              Patient
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <div class="form-row-wrapper">
      <div class="form-field input-row required">
        <label>Tâche</label>
        <div class="task-wrapper w-100">
          <select (ngModelChange)="doChangeTask($event)"
                  [(ngModel)]="task"
                  [disabled]="!taskTargetType"
                  [class.undef-class]="!task"
                  class="form-control form-select">
            <option [ngValue]="undefined" selected disabled>{{ getLabelSelectTask() }}</option>
            <option *ngFor="let t of filteredPredefinedTasks(predefinedTasks)" [ngValue]="t">{{ t.description }}</option>
          </select>
          <input *ngIf="isNameable(task)"
                 [(ngModel)]="toDo.taskTitle"
                 class="form-control form-field"
                 maxlength="25"
                 placeholder="Saisir le nom (25 car. max.)"
                 type="text">
        </div>
        <div class="invalid-feedback">
          Veuillez sélectionner un type de tâche.
        </div>
      </div>
    </div>

    <ng-container *ngIf="task && task !== '+'">

      <div class="form-row-wrapper">
        <div class="form-field input-row required">
          <label>Description</label>
          <ckeditor [(ngModel)]="toDo.description"
                    [config]="config"
                    [editor]="Editor"
                    class="msd-content">
          </ckeditor>
          <textarea [(ngModel)]="toDo.description" class="form-control content-textarea">
          </textarea>
        </div>
      </div>

      <div class="form-row-wrapper">
        <div class="form-field input-row required">
          <label>Échéance</label>
          <div class="date-wrapper">
            <input (change)="onDateStartChange($event.target)"
                   (paste)="pasteDate($event)"
                   [(ngModel)]="dateStart"
                   class="form-control date-input"
                   type="date">
          </div>
        </div>
      </div>
    </ng-container>

  </div>

  <div class="modal-footer">
    <button id="cancel-button" (click)="cancel();" type="button"
            class="btn btn-outline-primary btn-outline text-only">
      Annuler
    </button>

    <button id="validate-button" (click)="validate()" [disabled]="!enableValidate()" type="button"
            class="btn btn-primary btn-gradient">
      <ng-container *ngIf="isLoading else validateButton">
        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
        <span class="visually-hidden">Chargement...</span>
      </ng-container>
      <ng-template #validateButton>
        Valider
      </ng-template>
    </button>
  </div>
</div>
